import { TranslateService } from '@ngx-translate/core';
import { TimeoutError } from 'rxjs';

export const handleApiError = (
  error: any,
  translateService: TranslateService
): string => {
  let err;
  if (error instanceof TimeoutError) {
    err = translateService.instant('identification.timeoutError');
  } else {
    // TODO: Store error for future reference
    // err = JSON.stringify(error);
    err = translateService.instant('global.error.generalError');
  }

  // If the error is empty --- display nothing (otherwise a red pair of "{}" will appear)
  if (err === '{}') return '';

  return err;
};
